import SpaceMan from '@assets/PageNotFound/404-space-man.png';

import s from './NotFoundPage.module.css';

function NotFoundPage() {
  return (
    <div className={s.container}>
      <img className={s.spaceManImage} alt="404-page" src={SpaceMan} />
      <p className={s.spaceTitle}>
        Oops! Lost in space... <br />
        The page you’re looking for isn’t here.
      </p>
    </div>
  );
}

export default NotFoundPage;
